// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2eFtk","col":"Table_col__2s54z","fulfillmentStatus":"Table_fulfillmentStatus__2XvoL","emailCol":"Table_emailCol__1wtfb"};